import { defineStore } from 'pinia'


export const useEurodriveAuthStore = defineStore({
  id: 'eurodriveAuthStore',

  state: () => {
    const populated = false
    const user = localStorage.getItem('user') || 'null'
    return {
      populated,
      user: JSON.parse(user),
      userGroupsIDs: [] as string[],
      execGroupID: '',
      financeGroupID: '',
      longTermGroupID: '',
      backofficeGroupID: '',
      kvUserGroupID: ''
    }
  },

  getters: {
    // Group "vedení"
    isExecGroup() {
      return this.userGroupsIDs.includes(this.execGroupID)
    },
    isFinanceGroup() {
      return this.userGroupsIDs.includes(this.financeGroupID)
    },
    isLongTermGroup() {
      return this.userGroupsIDs.includes(this.longTermGroupID)
    },
    isBackofficeGroup() {
      return this.userGroupsIDs.includes(this.backofficeGroupID)
    },
    isKvUserGroup() {
      return this.userGroupsIDs.includes(this.kvUserGroupID)
    },
  },

  actions: {
    async populate(api: API) {
      await this.populateGroups(api)
      await this.populateGroupIDs(api)
      this.populated = true
    },
    async populateGroups(api: API) {
      const groups = await api.groups.getGroupsOfUser(this.user.id)
      this.userGroupsIDs = groups.value.map(g => g.id)
    },
    async populateGroupIDs(api: API) {
      // TODO Try-catch should not be necessary here - if getAttribute is not resolved dont throw a new error
      try {
        const execResult = await api.app.getAttribute('sspa.config.EURODRIVE_EXEC_ID')
        this.execGroupID = execResult.value
      } catch {
      }

      try {
        const financeResult = await api.app.getAttribute('sspa.config.EURODRIVE_FINANCE_ID')
        this.financeGroupID = financeResult.value
      } catch {
      }

      try {
        const longTermResult = await api.app.getAttribute('sspa.config.EURODRIVE_LONG_TERM_RENTAL_ID')
        this.longTermGroupID = longTermResult.value
      } catch {
      }

      try {
        const backofficeResult = await api.app.getAttribute('sspa.config.EURODRIVE_BACKOFFICE_ID')
        this.backofficeGroupID = backofficeResult.value
      } catch {
      }

      try {
        const kvUserResult = await api.app.getAttribute('sspa.config.EURODRIVE_KV_USER_ID')
        this.kvUserGroupID = kvUserResult.value
      } catch {
      }

    },

  }
})
